import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const extraPagesConfigs = [
  {
    auth: authRole.user,
    routes: [
      {
        path: '/welcome',
        component: React.lazy(() => import('./AboutUs')),
      },
      {
        path: '/user/:id/profile',
        component: React.lazy(() => import('./UserProfile/index')),
      },
    ],
  },
  // Temporarily commented out to prevent OpenCascade.js loading issues
  // {
  //   auth: authRole.user,
  //   routes: [
  //     {
  //       path: '/web-viewer',
  //       component: React.lazy(() => import('./WebViewer/index')),
  //     },
  //   ],
  // },
  {
    auth: authRole.user,
    routes: [
      {
        path: '/extra-pages/knowledge-base',
        component: React.lazy(() => import('./KnowledgeBase')),
      },
    ],
  },
  {
    auth: authRole.user,
    routes: [
      {
        path: '/extra-pages/portfolio',
        component: React.lazy(() => import('./Portfolio')),
      },
    ],
  },
  {
    auth: authRole.user,
    routes: [
      {
        path: '/extra-pages/faq',
        component: React.lazy(() => import('./FAQ')),
      },
    ],
  },
];
